<template>
  <div class="mainLayout">
      <el-container style="height: 100%; border: 1px solid #eee">
        <el-header style="text-align: right; font-size: 12px">
         <el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" @select="handleSelect"
              background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" router>
          <el-menu-item index="/emuInsert">处理中心</el-menu-item>
          <el-menu-item index="/releaseAnnouncement">公告</el-menu-item>
          <el-menu-item index="/UnServer">拒服</el-menu-item>
          <el-menu-item index="/MailMiss">发送失败</el-menu-item>
          <el-menu-item index="/Zhuizong">追踪</el-menu-item>
          <el-menu-item index="/Kaiji">监视开机</el-menu-item>
        </el-menu>
        </el-header>
        
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
  </div>
</template>

<script>
export default {
  name: 'mainLayout',
  data() {
    return {
        activeIndex: '/emuInsert',
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
      this.activeIndex = key;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
}

.el-aside {
    color: #333;
}
*{
  list-style: none
}
</style>
